import { Select } from 'antd';
import styled, { createGlobalStyle } from 'styled-components';

import CommonButton from '~atoms/CommonButton';
import PageTitle from '~atoms/PageTitle';

// Extracted to constant to satisfy sonarjs/no-duplicate-string linter rule
// This string literal appears 3 times in the file
const FLEX_START = 'flex-start';

export const GlobalSkeletonStyles = createGlobalStyle`
  @keyframes pulse {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }
`;

export const Container = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  fontSize: theme.typography.size16,
}));

export const Title = styled(PageTitle)({
  marginBottom: '20rem',
});

export const ContentWrapper = styled.div({
  display: 'flex',
  gap: '20rem',
  alignItems: FLEX_START,
});

export const RowsContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
});

export const Row = styled.div({
  display: 'flex',
  gap: '20rem',
  alignItems: 'center',
  lineHeight: '32rem',
});

export const RowTitle = styled.span(({ theme }) => ({
  minWidth: '128rem',
  textAlign: 'end',
  color: theme.palette.darkLiver,
}));

export const ImageContainer = styled.div({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  marginTop: '20rem',
});

export const ButtonContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: '8rem',
  alignItems: FLEX_START,
  alignSelf: FLEX_START,
});

export const SaveEstimateButton = styled(CommonButton)(({ theme }) => ({
  fontSize: theme.typography.size20,
}));

export const CheckboxContainer = styled.div({
  marginTop: '4rem',
});

export const SelectList = styled(Select<string>)(({ theme }) => ({
  '& .ant-select-selection-item': {
    fontSize: theme.typography.size16,
    fontFamily: theme.typography.family.arial,
    color: theme.palette.erieBlack,
  },
}));

export const SkeletonItem = styled.div(({ theme }) => ({
  '&[data-height="large"]': {
    height: '32rem',
  },
  '&[data-height="medium"]': {
    height: '16rem',
  },
  '&[data-width="small"]': {
    width: '120rem',
  },
  '&[data-width="medium"]': {
    width: '180rem',
  },
  '&[data-width="large"]': {
    width: '250rem',
  },
  backgroundColor: theme.palette.chineseWhite,
  borderRadius: '0.25rem',
  animation: 'pulse 1.5s ease-in-out infinite',
}));

export const SkeletonImage = styled.div(({ theme }) => ({
  width: '640rem',
  height: '200rem',
  backgroundColor: theme.palette.chineseWhite,
  borderRadius: '8rem',
  animation: 'pulse 1.5s ease-in-out infinite',
}));

export const StoresListContainer = styled.div({
  marginTop: '32rem',
});
